import Sentry from "@similarweb/sentry-logger";

import { TEAMS } from "app/constants/teamName";
import { DefaultFetchService } from "app/services/fetchService";

import type { IPackagesPrice } from "./types";

interface INTPackagesData {
    PackagesGroup: string;
    PackagesPrices: IPackagesPrice;
}
export const getPackages = async (workspace?: string): Promise<INTPackagesData | null> => {
    const fetchService = DefaultFetchService.getInstance();
    const workspaceQuery = workspace || "";

    try {
        const res = await fetchService.get<INTPackagesData>(`/api/nt-packages?workspace=${workspaceQuery}`);
        return res;
    } catch (error) {
        Sentry.error(`getPackages`, error, {
            extra: {
                cause: JSON.stringify((error as Error).cause),
            },
            tags: {
                team: TEAMS.LYNX,
            },
        });
        return null;
    }
};
